export default {
    backUrl: 'https://api.mobitruck.ru',
    frontUrl: 'https://app.mobitruck.ru',
    designImages: 'Элементы дизайна',
    previewTracksImages: 'Tracks',
    fullAndExactImages: 'full',
    itemImages: 'Изображения товаров',
    carcass: 'Каркас',
    defaultCategoryIcon: 'show.png',
}
